import { styled } from 'styled-components';
import FormFieldset from '@/components/forms/form/FormFieldset';

export const HelperTextMuted = styled.p`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  align-self: flex-start;

  span {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  width: 100%;
  margin-top: ${({ theme }) => theme.spaces.padding.md};
`;

export const StyledFormFieldset = styled(FormFieldset)`
  width: 100%;
`;
